/**
 * Comparison infographic greens from Figma/SVG assets. No matching token in
 * @sunrun/experience-ui-components (closest success tokens are different hues).
 */
const OFFER_REVIEW_COMPARISON_GREEN = "#20AC87";
const OFFER_REVIEW_COMPARISON_GAUGE_STROKE = "#23A589";

export { OFFER_REVIEW_COMPARISON_GAUGE_STROKE, OFFER_REVIEW_COMPARISON_GREEN };
